import React from 'react';
import { useVirtualAvatarGroups } from '../../hooks/useVirtualAvatarGroups';
import './virtualAvatarGroupSwitcher.css';

interface VirtualAvatarGroupSwitcherProps {
  /** 为 true 时拉取用户虚拟人像组（配置组 / 默认组） */
  active: boolean;
  className?: string;
  /** 未配置令牌时的提示；为 null 则不渲染 */
  noAuthHint?: string | null;
}

export const VirtualAvatarGroupSwitcher: React.FC<VirtualAvatarGroupSwitcherProps> = ({
  active,
  className,
  noAuthHint = '请先在「素材库」页配置系统访问令牌和用户 ID',
}) => {
  const { options, loading, hasAuth, selectedGroupId, selectGroupId } = useVirtualAvatarGroups(active);

  if (!hasAuth) {
    return noAuthHint ? (
      <div className={`vag-group-switcher${className ? ` ${className}` : ''}`}>
        <span className="vag-group-hint">{noAuthHint}</span>
      </div>
    ) : null;
  }

  if (loading && options.length === 0) {
    return (
      <div className={`vag-group-switcher${className ? ` ${className}` : ''}`}>
        <span className="vag-group-hint vag-group-hint--loading" role="status">
          加载素材组…
        </span>
      </div>
    );
  }

  if (options.length === 0) {
    return (
      <div className={`vag-group-switcher${className ? ` ${className}` : ''}`}>
        <span className="vag-group-hint">暂无可用素材组</span>
      </div>
    );
  }

  return (
    <div className={`vag-group-switcher${className ? ` ${className}` : ''}`}>
      <div className="vag-segmented" role="group" aria-label="虚拟人像素材组">
        {options.map((opt) => (
          <button
            key={opt.key}
            type="button"
            className={`vag-segmented-btn${selectedGroupId === opt.groupId ? ' on' : ''}`}
            title={opt.groupId}
            disabled={loading}
            onClick={() => selectGroupId(opt.groupId)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
};
